module.exports = __webpack_public_path__ + "img/lunch.4436ea0f.svg";